const omdb_api_key = `f2975268`;

module.exports = {
  omdb_api_key,
};
